import Grid from "@mui/material/Grid";

import i18n from "../../../../../constants/i18n";
import {
  BELONG_TO_A_TRIBE,
  EDUCATION_LEVEL,
  FEMALE_WORK_STUDY,
  INCOME,
  KHATTABAT_MATCHING_RESULTS_MATCH_APP_LANGUAGE,
  RELIGION,
  RELOCATION,
  SKIN_COLOR,
  SMOKING_LEVEL,
  VEIL,
  WORK_LEVEL
} from "../../../../../constants/picker-entries-constants";
import { KHATTABAT_MATCHING_FIELD_SIZE } from "../../../../../constants/user-profile";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import FilterMultiSelect from "./FilterMultiSelect";
import FilterSelect from "./FilterSelect";

const KhattabatMatchingLifestyleFilters = withLiteObserverAndTheme(() => {
  const shouldShowVeilOptions =
    getKhattabatMatchingStore().isMatchingVeilCriteriaExists.get();

  const shouldShowIncomeOptions =
    getKhattabatMatchingStore().isMatchingIncomeCriteriaExists.get();

  return (
    <>
      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterMultiSelect
          label={i18n.get("WORK_LEVEL")}
          options={WORK_LEVEL}
          value={getKhattabatMatchingStore().matchWork.get()}
          onChange={getKhattabatMatchingStore().setMatchWork}
        />
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterMultiSelect
          label={i18n.get("EDUCATION_LEVEL")}
          options={EDUCATION_LEVEL}
          value={getKhattabatMatchingStore().matchEducation.get()}
          onChange={getKhattabatMatchingStore().setMatchEducation}
        />
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("FEMALE_WORK_STUDY")}
          options={FEMALE_WORK_STUDY}
          value={getKhattabatMatchingStore().matchFemaleWorkStudy.get()}
          onChange={getKhattabatMatchingStore().setMatchFemaleWorkStudy}
        />
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("SMOKING_LEVEL")}
          options={SMOKING_LEVEL}
          value={getKhattabatMatchingStore().matchSmoking.get()}
          onChange={getKhattabatMatchingStore().setMatchSmoking}
        />
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("BELONGS_TO_TRIBE")}
          options={BELONG_TO_A_TRIBE}
          value={getKhattabatMatchingStore().matchBelongsToATribe.get()}
          onChange={getKhattabatMatchingStore().setMatchBelongsToATribe}
        />
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("RELOCATION")}
          options={RELOCATION}
          value={getKhattabatMatchingStore().matchRelocation.get()}
          onChange={getKhattabatMatchingStore().setMatchRelocation}
        />
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterMultiSelect
          label={i18n.get("SKIN_COLOR")}
          options={SKIN_COLOR}
          value={getKhattabatMatchingStore().matchSkinColor.get()}
          onChange={getKhattabatMatchingStore().setMatchSkinColor}
        />
      </Grid>

      {!shouldShowVeilOptions ? null : (
        <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
          <FilterMultiSelect
            label={i18n.get("VEIL")}
            options={VEIL}
            value={getKhattabatMatchingStore().matchFemaleVeil.get()}
            onChange={getKhattabatMatchingStore().setMatchFemaleVeil}
          />
        </Grid>
      )}

      {!shouldShowIncomeOptions ? null : (
        <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
          <FilterMultiSelect
            label={i18n.get("INCOME")}
            options={INCOME}
            value={getKhattabatMatchingStore().matchMaleIncome.get()}
            onChange={getKhattabatMatchingStore().setMatchMaleIncome}
          />
        </Grid>
      )}

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterMultiSelect
          label={i18n.get("RELIGION")}
          options={RELIGION}
          value={getKhattabatMatchingStore().matchReligion.get()}
          onChange={getKhattabatMatchingStore().setMatchReligion}
        />
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterMultiSelect
          label={i18n.get("MATCH_APP_LANGUAGE")}
          options={KHATTABAT_MATCHING_RESULTS_MATCH_APP_LANGUAGE}
          value={getKhattabatMatchingStore().matchAppLanguage.get()}
          onChange={getKhattabatMatchingStore().setMatchAppLanguage}
        />
      </Grid>
    </>
  );
});

export default KhattabatMatchingLifestyleFilters;
